export enum CoreApiMetaTags {
  ClientWebRoutes = 'ClientWebRoutes',
  ClientWebRouteMeta = 'ClientWebRouteMeta',
  ClientWebRoutesMeta = 'ClientWebRoutesMeta',
}

export const coreApiMetaTagTypes = Object.values(CoreApiMetaTags);
